import { Component, ViewChild, EventEmitter, Output } from "@angular/core";
import { SlickDialogComponent } from "@slick-components";
import { ICustomerModel } from "@models";
import { SleepService, CustomersService, GlobalsService } from "@services";
import { CustomerEditComponent } from "@app/customers/customer-components/customer-edit/customer-edit.component";


@Component({
	selector: "customer-edit-dialog",
	templateUrl: "customer-edit-dialog.component.html",
})

export class CustomerEditDialogComponent {
	@ViewChild("dialogRef", { static: true }) dialogRef: SlickDialogComponent;
	@ViewChild("customerEditRef") customerEditRef: CustomerEditComponent;
	@Output() onSavedChange = new EventEmitter();
	customerModel: ICustomerModel;
	// Summary mode opens on the customer dashboard; the pencil there switches to the edit form
	showSummary = false;
	isEditing = true;
	spinnerStatus: string;
	skeditPay: boolean = GlobalsService.company.useSkeditPay;
	agreementspinnerStatus: string;


	resolve: any;

	constructor(private customersService: CustomersService) {
	}

	openDialog(customerModel: ICustomerModel, showSummary: boolean = false): Promise<ICustomerModel> {
		return new Promise<ICustomerModel>((resolve) => {
			this.resolve = resolve;

			this.spinnerStatus = "reset";

			this.showSummary = showSummary === true && !!customerModel?.customerId;
			this.isEditing = !this.showSummary;

			this.customerModel = customerModel;
			this.dialogRef.showDialog();

            if (this.customerEditRef)
			    this.customerEditRef.clearSubmitted();
		})
	}

	async onSave() {
		try {
            if (this.customerEditRef)
				this.customerEditRef.setSubmitted();

			if (this.customerEditRef.isValid() === false) {
				this.spinnerStatus = "error";
				return;
			}

			this.spinnerStatus = "spin";
			const savedCustomer = await this.customerEditRef.saveCustomer();
			if (!savedCustomer) {
				this.spinnerStatus = "reset";
				return;
			}

			this.customerModel = savedCustomer;
			this.spinnerStatus = "ok";

			await SleepService.sleep(500);

			// In summary mode a save returns to the dashboard instead of closing
			if (this.showSummary) {
				this.spinnerStatus = "reset";
				this.onSavedChange.emit('Changed');
				return;
			}

            this.dialogRef.hideDialog();
			this.onSavedChange.emit('Changed');
            if (this.customerEditRef)
                this.customerEditRef.clearSubmitted();

			this.resolve(this.customerModel);
		}

		catch (err) {
			this.spinnerStatus = "error";
		}
	}

	onCancel() {
		if (this.showSummary && this.isEditing) {
			this.customerEditRef.cancelEditCustomer();
			return;
		}

		this.dialogRef.hideDialog();
		this.resolve(null);
	}

	async resetCustomerSignedStatus() {
		await this.customerEditRef.resetCustomerSignedStatus();
	}

	async sendServiceAgreement() {
		try {
			this.agreementspinnerStatus = "spin";
			await this.customerEditRef.sendServiceAgreement();
			this.agreementspinnerStatus = "ok";
		}
		catch {
			this.agreementspinnerStatus = "error";
		}
	}
}